// extracted by mini-css-extract-plugin
module.exports = {"score":"Score_score__nU4rt","score__pointer":"Score_score__pointer__tzhHa"};